import { Column } from 'react-table';

import { TrainingAndStandardisationStatusBagde, TrainingCategoryLabel } from 'components';
import { TrainingAndStandardisationReportRecordDto } from 'api';
import { formatDate } from 'utils';

export const columns: Column<TrainingAndStandardisationReportRecordDto>[] = [
  {
    Header: ' ',
    disableSortBy: true,
    columns: [
      {
        Header: '',
        width: '50px',
        accessor: 'category',
        disableSortBy: true,
        Cell: (x) => <TrainingCategoryLabel value={x.value} />,
      },
      {
        Header: 'First Name',
        accessor: 'examinerFirstName',
      },
      {
        Header: 'Last Name',
        accessor: 'examinerLastName',
      },
      {
        Header: 'Examiner number',
        accessor: 'examinerNumber',
      },
      {
        Header: 'Status',
        width: '100px',
        accessor: 'status',
        Cell: (x) => <TrainingAndStandardisationStatusBagde status={x.value} />,
      },
      {
        Header: 'Date',
        width: '90px',
        accessor: 'date',
        Cell: (x) => <>{formatDate(x.value)}</>,
      },
      {
        Header: 'Type',
        width: '100px',
        accessor: (x) => x.type,
      },
      {
        Header: 'Session name',
        accessor: 'sessionName',
      },
      {
        Header: 'Organising centre',
        width: '10%',
        accessor: 'organisingCentre',
      },
    ],
  },
  {
    Header: 'Examiner main centre',
    disableSortBy: true,
    columns: [
      {
        Header: 'Speaking',
        width: '150px',
        accessor: 'examinerMainSpeakingCentre',
      },
      {
        Header: 'Writing',
        width: '150px',
        accessor: 'examinerMainWritingCentre',
      },
    ],
  },
];
